import { Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import "./style.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@ts-digital/vrc";
// import { getVatEntries } from "../../../store/actions/reports/vatEntries";
import { getVatSettlemenDetails } from "../../../store/actions/reports/vatSettlement";

const Option = Select.Option;

const VatEntriesFilters = ({
  selectedBusiness,
  setSelectedBusiness,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  selectedType,
  setSelectedType
}) => {
  const currentYear = new Date().getFullYear();
  const intl = useIntl();
  const dispatch = useDispatch();
  // before to click into period I cannot change the business in header summary
  const [selectTempBusiness, setSelectTempBusiness] = useState(selectedBusiness);

  const businesses = useSelector(state => state.precog.activities?.data);

  useEffect(() => {
    if (!businesses) return;
    if (businesses.length === 1) {
      setSelectedBusiness(businesses[0].businessId);
    }
  }, [businesses]);
  
  const renderRange = (start, end) => {
    let items = [];
    if (start < end)
      for (let i = start; i <= end; i++) {
        items.push(<Option key={i} value={i}>
          {i}
        </Option>);
      }
    else
      for (let i = start; i >= end; i--) {
        items.push(<Option key={i} value={i}>
          {i}
        </Option>);
      }
    return items;
  };

  const renderMonths = () => {
    const monthsArray = [];
    const months = [
      "ANNUAL",
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER"
    ];
    months.forEach((el, index) => {
      monthsArray.push(<Option
        key={"months_select_" + el}
        value={el}
        label={intl.formatMessage({ id: `reports.vatEntries.${el}` })}       
      >
        <FormattedMessage id={"reports.vatEntries."+el} />
      </Option>);
    });

    return monthsArray;
  };

  const renderBusinesses = () => {
    const businessesArray = [];
    if (businesses?.length > 1) {
      businessesArray.push(<Option
        key={"businesses_select_all"}
        value={"all"}
        label={"Tutti"}
      >
        Tutti
      </Option>);
    } 
    businesses?.forEach((el, index) => {
      businessesArray.push(<Option
        key={"businesses_select_" + el.businessId}
        value={el.businessId}
        label={el.businessDescription}
      >
        {el.businessDescription}
      </Option>);
    });
    return businessesArray;
  };

  const renderTypes = () => {
    const typesArray = [];
    const types = [{ value: "Tutti", id: "all" }, { value: "Vendite", id: "SALE" }, { value: "Acquisti", id: "PURCHASE" }, { value: "Corrispettivi", id: "RECEIPT" }];
    types.forEach((el, index) => {
      typesArray.push(<Option
        key={"types_select_" + el.id}
        value={el.id}
        label={`${intl.formatMessage({ id: "reports.vatEntries.typeStarter" })} ${el.value}`}
      >
        {`${intl.formatMessage({ id: "reports.vatEntries.typeStarter" })} ${el.value}`}
      </Option>);
    });

    return typesArray;
  };
  
  const onSearchEntries = () => {
    dispatch(getVatSettlemenDetails(
      selectTempBusiness === "all" ? "" : selectTempBusiness, selectedYear, selectedMonth, "", selectedType === "all" ? "" : selectedType
    )).then(() => {
      setSelectedBusiness(selectTempBusiness);
    });
  };

  const renderTitle = () => {
    let title = "Seleziona il ";
    if (!selectedBusiness) {
      title = title + "business";
    } else if (!selectedMonth) {
      title = title + "periodo";
    } else if (!selectedType) {
      title = title + "tipo";
    } else {
      title = "";
    }
    return title;
  };

  return (
    <div style={{ margin: "0 40px", display: "flex", gap: "32px", flexDirection: "column" }}>
      <div style={{ display: "flex", gap: "32px" }}>   
        <div>
          <div><FormattedMessage id="reports.vatEntries.yearRef"/></div>
          <Select
            style={{width: 239, paddingTop: 4}}
            showSearch            
            placeholder={intl.formatMessage({id: "reports.vatEntries.yearSelectPlaceholder"})}
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            value={selectedYear}
            filterOption={(input, option) => {
              return option.children.toString().indexOf(input) >= 0;
            }}
            onSelect={value => {                
              setSelectedYear(value);                          
            }}
          >
            {renderRange(currentYear, 2012)}
          </Select>
        </div>  
        <div>
          <div><FormattedMessage id="reports.vatEntries.periodRef"/></div>
          <Select
            style={{width: 239, paddingTop: 4}}
            showSearch            
            placeholder={intl.formatMessage({id: "reports.vatEntries.periodRefPlaceholder"})}
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            value={selectedMonth}
            filterOption={(input, option) => {     
              // ?? is an operator of coalescence null if the left is undefined the right is used         
              return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());              
            }}
            onSelect={value => {                
              setSelectedMonth(value);                       
            }}
          >
            {renderMonths()}
          </Select>
        </div> 
        {businesses?.length > 1 && <div>
          <div><FormattedMessage id="reports.vatEntries.businessRef" /></div>
          <Select
            style={{ width: 239, paddingTop: 4 }}            
            showSearch
            placeholder={intl.formatMessage({ id: "reports.vatEntries.businessRefPlaceholder" })}
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            value={selectTempBusiness}
            filterOption={(input, option) => {                 
              // ?? is an operator of coalescence null if the left is undefined the right is used         
              return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());              
            }}
            onSelect={value => {
              setSelectTempBusiness(value);              
            }}
          >
            {renderBusinesses()}
          </Select>
        </div>}
        <div>
          <div><FormattedMessage id="reports.vatEntries.typeRef"/></div>
          <Select
            style={{width: 239, paddingTop: 4}}
            showSearch            
            placeholder={intl.formatMessage({id: "reports.vatEntries.typeRefPlaceholder"})}
            optionFilterProp="children"
            getPopupContainer={trigger => trigger.parentNode}
            value={selectedType}
            filterOption={(input, option) => {
              // ?? is an operator of coalescence null if the left is undefined the right is used         
              return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());              
            }}
            onSelect={value => {  
              setSelectedType(value);                       
            }}
          >
            {renderTypes()}
          </Select>
        </div> 
      </div>
      <div style={{ display: "flex", justifyContent: "end", gap: "16px" }}>
        {(selectedMonth || selectedBusiness || selectedType) &&
            <Button kind="secondary" onClick={() => { setSelectedBusiness(undefined); setSelectedMonth(undefined); setSelectedType(undefined);}}>
              <FormattedMessage id="reports.vatEntries.clearFilters" />
            </Button>
        }
        <Tooltip title={renderTitle()}>
          <Button kind="primary" disabled={!selectedMonth || (businesses?.lenght > 1 && !selectedBusiness) || !selectedType } onClick={() => onSearchEntries()}>
            <FormattedMessage id="actions.search" />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
export default VatEntriesFilters;
